import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const schemaDelivery = Yup.object({
  date: Yup.string().required('Please enter date'),
  hour: Yup.string().required('Please enter Hour'),
});
